<template>
  <div class="tableMy">
    <MyTable
      :table-data="tableData"
      :index="index"
      :page="page"
      :operation="operation"
      :table-option.sync="tableOption"
      @page-change="getList"
      @handleSelectionChange="handleSelectionChange"
    >
      <template slot="shop" slot-scope="scope">
        <div style="display: flex; align-items: center; justify-content: left">
          <div class="imageP">
            <p>
              {{ scope.row.shopName }}
            </p>
          </div>
        </div>
      </template>
      <template slot="tel" slot-scope="scope">
        <div style="display: flex; align-items: center; justify-content: left">
          <div class="imageP">
            <!-- <p>
              {{getStatus(scope.row.status) }}
            </p> -->
            <p>
              {{ scope.row.contactName }}
            </p>
            <p>
              {{ scope.row.contactPhone }}
            </p>
          </div>
        </div>
      </template>
      <template slot="information" slot-scope="scope">
        <div style="display: flex; align-items: center; justify-content: left">
          <div class="imageP" style="width: 100%">
            <p style="font-weight: 600; color: #262626">
              {{ scope.row.name || "-" }}
            </p>
            <p style="font-weight: 600; color: #262626">
              {{ scope.row.factory || "-" }}
            </p>
            <p>
              {{ scope.row.specification || "-" }}
            </p>
            <p>
              {{ scope.row.approvalNumber || "-" }}
            </p>
            <p>商品编码：{{ scope.row.goodsCode || "-" }}</p>
            <p>SKU编码：{{ scope.row.skuCode || "-" }}</p>
            <p>ERP编码：{{ scope.row.medicineCode || "-" }}</p>
          </div>
        </div>
      </template>
      <template slot="image" slot-scope="scope">
        <div style="display: column; align-items: center; justify-content: left">
          <div
            style="
              width: 100%;
              height: 100%px;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <el-image
              style="width: 80px"
              :src="scope.row.image || avater"
              :preview-src-list="[scope.row.image || avater]"
              lazy
            />
          </div>

          <div
            class="imageP"
            style="
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <p>
              {{ scope.row.name }}
            </p>
          </div>
        </div>
      </template>

      <template slot="price" slot-scope="scope">
        <div style="display: flex; align-items: center; justify-content: left">
          <div class="imageP">
            <p>价格：￥{{ scope.row.salePrice || "-" }}</p>
            <p>市场价：￥{{ scope.row.marketPrice || "-" }}</p>
            <p>建议零售价：￥{{ scope.row.purchasePrice || "-" }}</p>
          </div>
        </div>
      </template>
      <template slot="inventory" slot-scope="scope">
        <div style="display: flex; align-items: center; justify-content: left">
          <div class="imageP">
            <p>
              <el-tooltip
                class="item"
                effect="dark"
                content="总库存=ERP同步库存/手工设置商品总库存"
                placement="top"
              >
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
              总库存：{{ scope.row.goodsSkuInventory || "-" }}
            </p>
            <!-- <p>
              <el-tooltip class="item"
                          effect="dark"
                          content="可售库存=ERP同步库存手工设置商品库存-订单占用库存-活动占用库存"
                          placement="top">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip> 可售库存：{{'-'}}
            </p>
            <p>
              <el-tooltip class="item"
                          effect="dark"
                          content="待付款、待发货、配送中、配送完成、正在售后状态占用库存"
                          placement="top">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip> 订单占用库存：{{'-'}}
            </p>
            <p>
              <el-tooltip class="item"
                          effect="dark"
                          content="活动预占库存"
                          placement="top">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip> 活动占用库存：{{'-'}}
            </p> -->
            <p>最近效期：{{ scope.row.expireTime || "-" }}</p>
            <!-- <p>
              最远效期：{{scope.row.newExpireTime|| '-'}}
            </p>
            <p style="color: green;">
              ERP同步 :{{scope.row.beSynStock == '0' ? (scope.row.goodsSkuInventory || '-') : '-'}}
            </p> -->
          </div>
        </div>
      </template>
      <template slot="areaSchemeName" slot-scope="scope">
        <div style="display: flex; align-items: center; justify-content: left">
          <div class="imageP">
            <!-- <p>
              {{getStatus(scope.row.status) }}
            </p> -->
            <p>区域：{{ scope.row.areaSchemeName || "-" }}</p>
            <p>客户类型：{{ getShopTypeStr(scope.row.shopTypeCode) }}</p>
            <p>
              {{ `${scope.row.type == 0 ? "黑名单" : "白名单"}` }}：{{
                scope.row.groupSchemeName || "-"
              }}
            </p>
          </div>
        </div>
      </template>

      <template slot="status" slot-scope="scope">
        <div style="display: flex; align-items: center; justify-content: left">
          <div class="imageP">
            <p>
              {{ getStatus(scope.row.status) }}
            </p>
            <p>
              {{ scope.row.updateBy }}
            </p>
            <p>
              {{ scope.row.updateTime }}
            </p>
          </div>
        </div>
      </template>
      <template slot="saleSite" slot-scope="scope">
        <div style="display: flex; align-items: center; justify-content: left">
          <div class="imageP">
            <p>采购店数：{{ scope.row.purchaseShopCount }}</p>
            <p>采购数量：{{ scope.row.purchaseGoodsCount }}</p>
            <p>采购金额（元）：{{ scope.row.countMoney }}</p>
          </div>
        </div>
      </template>
      <template slot="remarks" slot-scope="scope">
        <div class="">
          <p>活动类型：{{ showActivityName(scope.row.activityType) }}</p>
        </div>
      </template>
      <template slot="caozuo" slot-scope="scope">
        <!-- <el-button type="button" size="mini" icon="el-icon-upload2" @click="deleteHandle(scope.row)">上架</el-button> -->
        <div style="display: flex; justify-content: space-evenly">
          <!-- <el-link :underline="false"
                   v-if="activeName == 'MERCHANT_REMOVAL'"
                   type="primary"
                   @click="listing(scope.row)">上架</el-link> -->

          <el-link
            :underline="false"
            v-if="scope.row.canPlatformPutAway"
            type="primary"
            @click="listing(scope.row)"
            >上架</el-link
          >
          <el-link
            :underline="false"
            v-if="activeName == 'ON_SALE'"
            type="primary"
            @click="openDialog(scope.row)"
            >下架</el-link
          >
          <el-link :underline="false" type="primary" @click="detailHandle(scope.row)"
            >详情</el-link
          >
          <!-- <el-link :underline="false"
                   v-if="activeName == 'ON_SALE' || activeName == 'MERCHANT_REMOVAL' || activeName == 'SKU_AWAIT'|| activeName == 'SKU_FAIL'|| activeName == 'BASE_TEMPORARY_FAIL'"
                   type="primary"
                   @click="editHandle(scope.row)">编辑</el-link>
          <el-link :underline="false"
                   v-if="activeName == 'BASE_ALREADY'"
                   type="primary"
                   @click="addStash(scope.row)">加入仓库</el-link> -->
        </div>

        <!-- <div style="display: flex;justify-content: center;">
          <el-link :underline="false"
                   type="primary"
                   @click="logs(scope.row)">操作日志</el-link>
        </div> -->
      </template>
    </MyTable>

    <!-- 下架弹窗 -->
    <el-dialog
      title="下架商品"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
    >
      <el-form ref="soldOutReason" :model="formTool" :rules="rules" size="small">
        <el-form-item label="" prop="reason">
          <el-input
            v-model.trim="formTool.reason"
            type="textarea"
            placeholder="请输入50字以内下架原因"
            :row="2"
            style="width: 100%"
            maxlength="50"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitFileForm">确认下架</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getunitList, getEnableListByType } from "@/api/productManage/auditProduct";
import MyTable from "@/components/myTable";
import { checkSkuStatus } from "@/utils/status";
import avater from "/public/img/default.png";

export default {
  components: { MyTable },
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    page: {
      type: Object,
      default() {
        return {};
      },
    },
    selectionList: {
      type: Array,
      default() {
        return [];
      },
    },
    activeName: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      shopTypeList: [],
      avater: avater,

      // selectionList: [],
      operation: false,
      // selection: true,
      index: false,
      // tableData: [],
      tableOption: [
        { label: "店铺信息", prop: "shop", slot: true, minWidth: "200px" }, // 这里表示自定义列
        { label: "运营人员&联系方式", prop: "tel", slot: true, minWidth: "200px" }, // 这里表示自定义列
        { label: "商品信息", prop: "information", slot: true, minWidth: "200px" }, // 这里表示自定义列
        {
          label: "展示名称",
          prop: "image",
          slot: true,
          minWidth: "200px",
          align: "center",
        }, // 这里表示自定义列
        // { label: '商品名称', prop: 'name' },
        // { label: '生产厂商', prop: 'factory' },
        { label: "价格", prop: "price", slot: true, width: "260px" },
        { label: "库存", prop: "inventory", slot: true, width: "260px" },
        {
          label: "控销规则",
          prop: "areaSchemeName",
          slot: true,
          width: "260px",
        },
        { label: "销售情况", prop: "saleSite", slot: true, width: "160px" },
        // { label: "商品状态", prop: "status", slot: true, width: "160px" },
        // { label: '批准文号', prop: 'approvalNumber', width: "260px" },
        { label: "备注", prop: "remarks", slot: true, width: "160px" },
        { label: "操作", prop: "caozuo", slot: true, align: "center", width: "120px" },
        // { label: 'ERP编码', prop: 'medicineCode' },
        // { label: '发布时间', prop: 'createTime', width: "180px" }
      ],
      // page: {
      //   total: 1,
      //   current: 1,
      //   size: 20,
      // }
      dialogVisible: false, // 下架弹窗
      formTool: {
        reason: "", // 下架原因
      },
      rules: {
        reason: [{ required: true, message: "请输入下架原因", trigger: "blur" }],
      },
      currentRow: {},
    };
  },
  computed: {
    getStatus() {
      return (status) => checkSkuStatus(status);
    },
  },
  created() {
    this.getEnableListByType();
  },
  mounted() {},
  watch: {},
  methods: {
    // 获取类型
    getEnableListByType() {
      let params = {
        type: 0,
      };
      getEnableListByType(params).then((res) => {
        console.log(res, "getEnableListByType");
        if (res.code == 0) {
          this.shopTypeList = res.data;
        }
      });
    },
    getShopTypeStr(v) {
      if (!v) {
        return "-";
      }
      const arr = v.split(",");
      let strArr = [];
      arr.forEach((e) => {
        this.shopTypeList.forEach((l) => {
          if (e == l.typeCode) {
            strArr.push(l.typeName);
          }
        });
      });
      return strArr.join(",");
    },
    showActivityName(activityType) {
      const typeList = [
        {
          label: "一口价",
          value: 1,
        },
        {
          label: "特价",
          value: 2,
        },
        {
          label: "单品包邮",
          value: 3,
        },
        {
          label: "赠品",
          value: 4,
        },
      ];
      const findedItem = typeList.find((item) => item.value == activityType);
      return findedItem ? findedItem.label : "-";
    },
    // 切换分页
    getList() {
      this.$emit("getList", this.page);
    },
    // 勾选
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    // 日志
    logs(val) {
      this.$emit("logs", val);
    },
    // 编辑
    editHandle(val) {
      this.$emit("editHandle", val);
    },
    // 详情
    detailHandle(val) {
      this.$emit("detailHandle", val);
    },
    // 编辑下架原因
    openDialog(val) {
      this.dialogVisible = true;
      this.currentRow = val;
    },
    handleClose() {
      this.dialogVisible = false;
      this.formTool.reason = "";
    },
    // 下架
    submitFileForm() {
      this.$refs["soldOutReason"].validate((valid) => {
        if (!valid) {
          return;
        }
        this.currentRow.soldOutReason = this.formTool.reason;
        this.handleClose();
        this.$emit("delist", this.currentRow);
      });
    },
    // 上架
    listing(val) {
      this.$emit("listing", val);
    },
    // 加入仓库
    addStash(val) {
      this.$emit("addStash", val);
    },
  },
};
</script>
<style lang="scss" scoped>
.tableMy {
  width: 100%;
  height: 100%;
}
</style>
